import { Lock } from "lucide-react";

export default function AdminLogin() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirect = `${window.location.origin}/admin/auth/callback`;
  const url = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;

  return (
    <div className="auth-shell" data-testid="admin-login">
      <div className="auth-card">
        <Lock size={22} />
        <p className="eyebrow">Zorba Admin</p>
        <h1>Sign in to continue</h1>
        <p className="muted">
          The admin panel is restricted to Zorba International Spa team members. Sign in with your
          allowlisted Google account to manage offers, gift vouchers and SEO content.
        </p>
        <a className="btn btn-primary full" href={url} data-testid="google-signin-button">
          Sign in with Google
        </a>
        <p className="muted-small">
          You'll be redirected to the Emergent-managed Google sign-in. No OAuth setup is required on your side.
        </p>
      </div>
    </div>
  );
}
